import { provideStoreDevtools } from '@ngrx/store-devtools'

export const extProviders = [
  provideStoreDevtools({
    maxAge: 25,
    name: 'Performance BackOffice',
  }),
]
